// Articles List Page 

<template>
	<div class="art-list-comp">

		<div class="params-layout">
			<div class="btn-search" @click="clickSearch">
				<UniIcon ico="mag" fit="1" pad="4" color="#369" />
			</div>

			<div class="h-spacer" />

			<div class="param">
				Results: <br/> {{ pager.totRecs }} Stories
			</div>

			<div class="h-spacer" />

			<div class="param">
				Category: <br/> {{ result.cat.title }}
			</div>
			
			<div class="h-spacer" />

			<div class="param" v-if="result.keyword!=''">
				Keyword:  <br/> {{ result.keyword }}
			</div>
			
			<div class="h-spacer" />

			<div class="param" v-if="result.dateBeg!='' || result.dateEnd!='' ">
				{{ result.dateBeg }} - <br/> {{ result.dateEnd }}
			</div>
		</div>
		

		<!-- Articles List -->
		<div class="content-layout">

			<div class="no-arts" @click="clickSearch" v-if="arts.length==0 && !wait">
				No Articles found. <br />
				Try changing your search terms <br />
				<UniIcon ico="mag" color="#369" w="60" h="60" /><br/>
				Search again
			</div>

			<ArtMini 
				v-for="(rec, idx) in arts" 
				:key="'mini'+idx" 
				:rec="rec"
				:idx="idx"
				:role="role"
			/>
		
		</div>

		<!-- Pager -->
		<div class="pager-layout">
			<UniPager />
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
import { eventBus } from '@/main';
import ArtMini from '@/views/usr/ArtMini';
export default {
	components: {
		ArtMini,
	},
	computed: {
		...mapState('api', ['source', 'wait']),
		...mapState('app', ['result', 'arts', 'role', 'pager', 'firstSearch']),
	},
	methods: {
		clickSearch() {
			this.$router.push('search');
		},
	},
	created() {
		m("usr art list created");
		eventBus.$emit('popoffall'); // Close all modal windows
		if (this.firstSearch) {
			this.$store.dispatch('app/reqArticles')
		}
	},
}
</script>

<style scoped>
.art-list-comp {
	height: 100%;
	overflow: hidden;
	background-color: #F9F6F3;
	padding: 5px 0px 0px 5px;
	border: solid 0px #090;
}

.params-layout {
	height: 45px;
	overflow: hidden;
	border: solid 0px #369;
}

.param {
	display: inline-block;
	width: 70px;
	height: 40px;
	overflow: hidden;
	white-space: nowrap;
	vertical-align: top;
	border: solid 0px #C30;
}

.btn-search {
	display: inline-block;
	width: 36px;
	height: 36px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	border: solid 0px #369;
}

.h-spacer {
	display: inline-block;
	width: 5px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	border: solid 0px #000;
}

.content-layout {
	height: calc(100% - 125px);
	overflow-x:hidden;
	overflow-y: scroll;
	background-color: #F6F6F6;
	/* border-radius: 10px; */
	border-top: solid 2px #999;
	border-bottom: solid 2px #999;
	/* border: solid 1px #999; */
}

.pager-layout {
	height: 75px;
	overflow: hidden;
	padding: 10px;
	border: solid 0px #369;
}

.no-arts {
	position: relative;
	top: 20px;
	width: 250px;
	height: 160px;
	overflow: hidden;
	margin: auto;
	text-align: center;
	cursor: pointer;
	padding: 20px;
	border-radius: 10px;
	border: solid 2px #369;
}

</style>
